import httpInstances from '@/api/axiosInstance';

export const downloadJsonFileFromDatalake = async (fileName: string, fileGroup: string) => {
  return httpInstances.axiosInternalInstance
    .get(`/proxy/datalake/file?fileName=${fileName}&groupName=${fileGroup}`)
    .then(response => {
      if (response.status === 200) {
        return response.data;
      }
      throw new Error('File not found');
    });
};
